const PHONE_NUMBER_REGEXP = /(\d{3})(\d{3})(\d{4})/;

export const phoneFormat = (phoneNumber: string | null) => {
    const cleanPhoneNumber = phoneNumber?.replace(/\D/g, '');
    return cleanPhoneNumber?.length === 10 ? cleanPhoneNumber.replace(PHONE_NUMBER_REGEXP, '($1) $2-$3') : null;
};
